var map = {
	"./api.svg": "7476",
	"./auto-fx.svg": "85dd",
	"./card-nobrand.svg": "5e82",
	"./card.svg": "2d9e",
	"./change-password.svg": "b58b",
	"./check-circle.svg": "bad0",
	"./customer-setting.svg": "9a1c",
	"./dashboard.svg": "f782",
	"./deposit.svg": "c44e",
	"./device.svg": "2c87",
	"./domestic.svg": "ef083",
	"./favorite.svg": "cd8e",
	"./instant-bank-transfer.svg": "1a6d",
	"./introducer.svg": "993b",
	"./logout.svg": "0175",
	"./mastercard.svg": "4f39",
	"./mobile.svg": "30d4",
	"./notification.svg": "1ca6",
	"./payee.svg": "11d4",
	"./payment.svg": "ea4f",
	"./pending.svg": "f51c",
	"./profile.svg": "f93a",
	"./receive-bank-transfer.svg": "66d1",
	"./request-fx.svg": "4c40",
	"./select.svg": "064a",
	"./send.svg": "94d0",
	"./standing-order.svg": "8439",
	"./statement.svg": "d667",
	"./swiftpayment.svg": "5a04",
	"./tariff.svg": "f68d",
	"./terms-and-conditions.svg": "44c4",
	"./upgrade.svg": "b33e",
	"./user-management.svg": "5e6c",
	"./visa.svg": "ba3f",
	"./wallet.svg": "402b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";